module.exports = __webpack_public_path__ + "img/特色基地营地.43c1da3f.jpg";